import { ProactivePrescriptionRulesStore } from '@common/stores/ProactivePrescriptionRulesStore';
import React, { createContext, useContext } from 'react';

interface IProactivePrescriptionRuleProviderProps {}

const ProactivePrescripitonRuleContext =
  createContext<ProactivePrescriptionRulesStore | null>(null);

export const ProactivePrescriptionRuleProvider = ({
  children,
}: React.PropsWithChildren<IProactivePrescriptionRuleProviderProps>) => {
  const proactivePrescriptionRuleStore = React.useMemo(() => {
    return new ProactivePrescriptionRulesStore();
  }, []);

  return (
    <ProactivePrescripitonRuleContext.Provider
      value={proactivePrescriptionRuleStore}
    >
      {children}
    </ProactivePrescripitonRuleContext.Provider>
  );
};

export const useProactivePrescriptionRuleStore = () => {
  const store = useContext(ProactivePrescripitonRuleContext);
  if (!store)
    throw new Error(
      'useProactivePrescriptionRuleStore must be used within a ProactivePrescriptionRuleProvider',
    );
  return store;
};
